import React from 'react';
import I18n from '~/utils/translations';

import CobrandedLogo from '~/components/agent_form/cobranded_logo';

const Header = ({ logo }) => {
  return (
    <header className="agents-header" style={{ backgroundImage: `url(${I18n.t('pages.agents_form.header.bg_image')}` }}>
      <div className="agents-header__inner">
        <div className="agents-header__content">
          <h1 className="agents-header__title">{I18n.t('pages.agents_form.header.title')}</h1>
          <p className="agents-header__subtitle">{I18n.t('pages.agents_form.header.subtitle')}</p>
        </div>
        <CobrandedLogo customClass="agent-form" logo={logo} />
      </div>
    </header>
  );
};

export default Header;
